import { makeStyles, tokens } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageHelpPageDocumentsStyles = makeStyles({
  errorMessage: {
    marginTop: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalS,
    backgroundColor: tokens.colorPaletteRedBackground1,
    borderRadius: tokens.borderRadiusSmall,
    border: `1px solid ${tokens.colorPaletteRedBorder1}`,
  },

  uploadingState: {
    position: "fixed",
    bottom: tokens.spacingVerticalL,
    right: tokens.spacingVerticalL,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow4,
  },

  pathText: {
    color: tokens.colorNeutralForeground3,
    marginTop: tokens.spacingVerticalXS,
    wordBreak: "break-word",
    overflowWrap: "break-word",
    display: "block",
  },

  documentInfo: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
  },

  documentName: {
    wordBreak: "break-word",
    overflowWrap: "break-word",
    display: "block",
  },
});
